import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/awsReport',
  component: layout,
  meta: {
    funcID: 'E0003',
    PID: 'E00',
  },
  children: ((pre) => [
    {
      path: 'inventoryList',
      name: `${pre}inventoryList`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000302',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/inventoryList'),
    },
    {
      path: 'advertisingList',
      name: `${pre}advertisingList`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000303',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/advertisingList'),
    },
    {
      path: 'salesList',
      name: `${pre}salesList`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000301',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/salesList'),
    },
    {
      path: 'skuDataList',
      name: `${pre}skuDataList`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000304',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/skuDataList'),
    },
    {
      path: 'storeDataList',
      name: `${pre}storeDataList`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000305',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/storeDataList'),
    },
    {
      path: 'skuInv',
      name: `${pre}skuInv`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000308',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/skuInv'),
    },
    {
      path: 'skuInvFty',
      name: `${pre}skuInvFty`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000309',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/skuInvFty'),
    },
    {
      path: 'orderBoard',
      name: `${pre}ecomamzrecordorder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000310',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/ecomamzrecordorder'),
    },
    {
      path: 'skuInvFtyLocation',
      name: `${pre}skuInvFtyLocation`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000311',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/skuInvFtyLocation'),
    },
    {
      path: 'skuOutageStatistics',
      name: `${pre}skuOutageStatistics`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000312',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/skuOutageStatistics'),
    },
    {
      path: 'keySkuInvMonitored',
      name: `${pre}keySkuInvMonitored`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000313',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/keySkuInvMonitored'),
    },
    {
      path: 'skuInvOutOfStock',
      name: `${pre}skuInvOutOfStock`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000314',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/skuInvOutOfStock'),
    },
    {
      path: 'replenishmentAndReorder',
      name: `${pre}replenishmentAndReorder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000315',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/replenishmentAndReorder'),
    },
    {
      path: 'inOutRecords',
      name: `${pre}inOutRecords`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000316',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/inOutRecords'),
    },
    {
      path: 'settlementList',
      name: `${pre}settlementList`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000317',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/settlementList'),
    },
    {
      path: 'noShipRecord',
      name: `${pre}noShipRecord`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000318',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsReport/noShipRecord'),
    },
  ])('ecom-awsReport-'),
}
